import { useIntl } from 'react-intl';

export const useTranslation = () => {
  const intl = useIntl();

  const t = (id: string, values = {}) => {
    return intl.formatMessage({ id }, values);
  };

  const { locale } = intl;

  return { t, locale };
};
